export default __webpack_public_path__ + "b7ea86790f97f762842d00c2afd1735a.png";